import {
  Excel,
  QueryBuilder,
  Trend,
} from '../../views/pages/Mobile';

export default [{
  path: '/mobile',
  name: 'Mobile Default',
  component: () => null,
  routes: [{
    path: '/excel',
    name: 'Excel',
    component: Excel,
  }, {
    path: '/trend',
    name: 'Trend',
    component: Trend,
  }, {
    path: '/query-builder',
    name: 'Query Builder',
    component: QueryBuilder,
  }],
}];
